import request from '../../axios/axiosconfig.js'

/**
 * 查询代理列表
 * @param {*} params 
 * @returns 
 */
export function getCsList(params) {
  return request({
    url: '/ps/csList/getAllCs',
    method: 'get',
    params: params,
    timeout: 20000
  })
}

/**
 * 查询代理详细信息
 * @param {*} params 
 * @returns 
 */
export function getCsInfoById(params) {
  return request({
    url: '/ps/csList/getCsInfoById/'+params,
    method: 'get',
  })
}

/**
 * 查询代理详细信息
 * @param {*} data 
 * @returns 
 */
 export function updateCs(data) {
  return request({
    url: '/ps/csList/updateCs',
    method: 'post',
    data: data
  })
}
  


// WEBPACK FOOTER //
// ./src/api/usermanagement/csList.js